    
    <script>
   
    export let link="";
    export let logo="";
    export let botao="";
    export let descricao="";
    export let corDescricao="#ffffff";
    export let corCabecalho="#ffffff";
    export let corLetraCabecalho="#000000";
    export let larguraMaxima="300px";
    export let sombraLogo1=0;
    export let sombraLogo2=0;
    export let sombraLogo3=0;
    export let sombraLogo4=0;
    export let sombraDescricao1=0;
    export let sombraDescricao2=0;
    export let sombraDescricao3=0;
    export let sombraDescricao4=0;


    export let espacamentoDescricaoSuperior=0;
    export let espacamentoDescricaoInferior=0;
    export let corSombraLogo="#ffffff";
    export let corSombraDescricao="#ffffff";
    export let fonteDescricao="";
    export let tamanhoLetraDescricao=16;
    let fonte="";
   $:sombraLogo1=sombraLogo1+"px";
   $:sombraLogo2=sombraLogo2+"px";
   $:sombraLogo3=sombraLogo3+"px";
   $:sombraLogo4=sombraLogo4+"px";
   $:sombraDescricao1=sombraDescricao1+"px";
   $:sombraDescricao2=sombraDescricao2+"px";
   $:sombraDescricao3=sombraDescricao3+"px";
   $:sombraDescricao4=sombraDescricao4+"px";
   $:tamanhoLetraDescricao1=tamanhoLetraDescricao+"px";
   $:espacamentoDescricaoInferior=espacamentoDescricaoInferior+"px";
   $:espacamentoDescricaoSuperior=espacamentoDescricaoSuperior+"px";
   $:if (fonteDescricao!=""){
     console.log(fonteDescricao);
     
     fonte="font-family:"+fonteDescricao;
      console.log(fonte);
   }else{
     fonte="";
   }

   
    export let corLetraDescricao="#000000";
    let url;
    
    $:descricao=descricao.replace("\n","<br>");
    </script>
    <style>
    @import url("https://fonts.googleapis.com/css2?family=Anton&family=Dancing+Script&family=Dosis&family=Lobster&family=Montserrat:wght@700&family=Pacifico&family=Roboto+Slab:wght@100&family=Roboto:wght@100&display=swap");
      
     
       .descricao{
           
           background-color: var(--corDescricao);
           color: var(--corLetra);

       }
       .largura-fixa-logo{

         max-width: 300px;
        

       }
    .font-roboto{
        font-family: 'Roboto Slab', serif;
    }
    </style>
    
    <section>
      <div class="text-center mt-2" style="background-color:{corCabecalho}; color: {corLetraCabecalho}">
        <div class="container">
          <div class="row">
            <div class="col-12">
			<br>
             {#if logo==""}
             
                <img src="img/basico-01.png" style="max-width:{larguraMaxima} ;  box-shadow: {sombraLogo1} {sombraLogo2} {sombraLogo3} {sombraLogo4} {corSombraLogo}; "  alt="" />
             {/if}
             {#if logo!=""}
            
                
                <img src="{logo}" style="max-width:{larguraMaxima};  height: auto; box-shadow: {sombraLogo1} {sombraLogo2} {sombraLogo3}  {sombraLogo4} {corSombraLogo}; "   alt="" />
             {/if}
             
			 
			                
              <p>&nbsp;</p>
			 
              <!---<p><a class="btn btn-primary btn-lg" href="#" role="button">Learn more »</a></p>-->
            </div>
          </div>
        </div>
      </div>
	  	</section>
   
	  
	  
	  
	  <section>
  
    
	   <div class=" text-center mt-2 descricao" style="--corDescricao:{corDescricao}; box-shadow: {sombraDescricao1} 
     {sombraDescricao2} {sombraDescricao3} {sombraDescricao4} {corSombraDescricao} ">
        <div class="container">
          <div class="row" style="height:{espacamentoDescricaoSuperior};"></div>
          <div class="row">
            <div class="col-12" >
            <p ></p>
        
            <h3 class="descricao " style ="--corLetra:{corLetraDescricao};  margin-bottom:{espacamentoDescricaoInferior}; {fonte} ; font-size:{tamanhoLetraDescricao1}">{@html descricao}	</h3> 
        <p></p>
				</div> 
			  </div>
			</div>
		   </div>
		  </section>
	  
	  
	      

   
		
	 
	  
		 

    
    